import * as endpoints from '../helpers/endpoints';
import * as types from './action-types';
import apiRequest from '../helpers/apiRequest';
import searchFormat from '../helpers/search';
import { actions } from 'react-redux-form';
import getStatus from '../helpers/status-substatus';

export const setCalendarView = view => ({
    type: types.SET_CALENDAR_VIEW,
    view
});

export const setCalendarActive = active => ({
    type: types.SET_CALENDAR_ACTIVE,
    active
});

export const fetchCalendarSuccess = (payload, newData) => ({
    type: types.FETCH_CALENDAR_SUCCESS,
    payload,
    newData
});

export const setEventWindowStart = value => ({
    type: types.SET_EVENT_WINDOW_START,
    value
});

export const setEventWindowEnd = value => ({
    type: types.SET_EVENT_WINDOW_END,
    value
});

export const fetchCalendarThunk = (paramObj = null, newData = false) => (
    dispatch,
    getState
) => {
    let userInfoCode = '';
    const filters = getState().calendarFilters;
    const rssOssType = filters.rssOssType;
    const rssOssCode = `${filters.rssOssCode}`.includes('-')
        ? filters.rssOssCode.split('-')[0]
        : filters.rssOssCode;
    const userInfo = getState().data.userInfo;
    const billetLocation = userInfo.Billet.location;
    dispatch(calLoading());

    if (rssOssType === 'RSS') {
        userInfoCode =
            '&filters[Event][recruitingSubStationCode][eq]=' + rssOssCode;
    } else if (rssOssType === 'OSS') {
        userInfoCode = '&filters[Event][ossCode][eq]=' + rssOssCode;
    } else if (filters.recruitingStationCode) {
        userInfoCode =
            '&filters[Event][recruitingStationCode][eq]=' +
            filters.recruitingStationCode;
    } else if (filters.districtCode) {
        userInfoCode =
            '&filters[Event][districtCode][eq]=' + filters.districtCode;
    } else if (filters.regionCode) {
        userInfoCode = '&filters[Event][regionCode][eq]=' + filters.regionCode;
    }

    const statusConversion = {
        AfterActionReview: 'status-aaReview', //Approved
        EventCreation: 'status-creation', //Incomplete
        EventReview: 'status-review', //Unapproved
        AfterActionDeleted: 'status-deleted', //Deleted
        AfterActionIncomplete: 'status-aaIncomplete', //Rejected
        AfterActionPending: 'status-aaPending' //Pending
    };

    let eventReportParam = '&include[]=EventReport&include[]=Category';
    let params = '';
    if (paramObj) {
        const keys = Object.keys(paramObj);
        const arr = [];
        for (let i = 0; i < keys.length; i += 1) {
            let key = keys[i];
            let value = paramObj[key];

            switch (key) {
                case 'startDate':
                    key = 'filters[Event][startDate][gte]';
                    break;
                case 'endDate':
                    key = 'filters[Event][startDate][lte]';
                    break;
                default:
                    break;
            }

            arr.push(`${key}=${value}`);
        }
        params = `${arr.join('&')}`;
    }

    let readOnlyFilter = '';
    if (
        !getState().data.userInfo.permissions.resources.Event.includes('Create')
    ) {
        readOnlyFilter = '&filters[Event][status][notin]=Incomplete';
    }

    // Fetch only Approved, Unapproved, and Incomplete events
    apiRequest(
        `${
            endpoints.EVENT_SEARCH_PATH
        }?${params}${readOnlyFilter}${eventReportParam}${userInfoCode}`,
        getState().auth.jwtToken
    )
        .then(response => {
            const mappedResults = response.data.map(item => {
                let eventReportStatusValue = 'Incomplete';
                let formattedTitle = '';
                let classNames;
                let groupStatus = getStatus(
                    item.status,
                    item.subStatus,
                    item.EventReport,
                    item.startDate
                );
                if (
                    statusConversion.hasOwnProperty(
                        groupStatus.status.replace(/\s/g, '')
                    )
                ) {
                    classNames =
                        statusConversion[groupStatus.status.replace(/\s/g, '')];
                } else {
                    classNames = 'status-default';
                }

                if (!!item.EventReport) {
                    if (item.EventReport.status !== '') {
                        eventReportStatusValue = item.EventReport.status;
                    }
                }

                if (billetLocation === 'RSS' || billetLocation === '0SS') {
                    formattedTitle = item.name;
                } else {
                    formattedTitle = item.qualifiedName;
                }

                //Check if category contains Influencer
                let influencerEvents = item.Category.some(
                    item => item.name === 'Influencer Event'
                );

                let rssOssCode = '';
                let rssOssType = '';
                //Check if event is OSS or RSS
                if (item.recruitingSubStationCode) {
                    rssOssCode = item.recruitingSubStationCode;
                    rssOssType = 'RSS';
                } else if (item.ossCode) {
                    rssOssCode = item.ossCode;
                    rssOssType = 'OSS';
                }

                return {
                    title: item.name,
                    location: `${item.city}, ${item.state}`,
                    className: classNames,
                    url: item.links[0].self,
                    start: new Date(item.startDate),
                    end: item.endDate
                        ? new Date(item.endDate)
                        : new Date(item.startDate),
                    status: item.status,
                    eventStatus: groupStatus.status,
                    eventSubStatus: groupStatus.subStatus,
                    eventReportStatus: eventReportStatusValue,
                    region: item.regionCode,
                    district: item.districtCode,
                    recruitingStationCode: item.recruitingStationCode,
                    rssOssCode: rssOssCode,
                    rssOssType: rssOssType,
                    isFromEac: item.isFromEac,
                    isFromPr: influencerEvents ? true : false,
                    EventReport: item.EventReport,
                    qualifiedName: item.qualifiedName,
                    formattedTitle: formattedTitle,
                    createdById: item.createdById
                };
            });

            //This will only show the users incomplete event on their calendar
            //Also remove rejected events on everyone's calendar.
            const filterMappedResults = mappedResults.filter(event => {
                if (event.status === 'Rejected') {
                    return false;
                }
                if (event.status === 'Incomplete') {
                    if (event.createdById === getState().data.userInfo.id) {
                        return true;
                    } else {
                        return false;
                    }
                }
                return true;
            });
            dispatch(fetchCalendarSuccess(filterMappedResults, newData));
            dispatch(calLoadingSuccess());
        })
        .catch(error => {
            console.log(error);
        });
};

export const resetCalendarBtn = () => dispatch => {
    dispatch(actions.reset('calendarFilters'));
    dispatch(onLoadCalendarLocations('calendarFilters'));
};

export const resetCalEvents = () => dispatch => {
    dispatch(resetData());
    dispatch(actions.reset('calendarFilters'));
};

export const resetData = () => {
    return {
        type: types.RESET_CAL_EVENTS
    };
};

export const calLoading = () => {
    return {
        type: types.CAL_LOADING
    };
};

export const calLoadingSuccess = () => {
    return {
        type: types.CAL_LOADING_SUCCESS
    };
};

export const toggleFilter = value => ({
    type: types.TOGGLE_FILTER,
    value
});

export const setFocusDate = (direction, increment) => ({
    type: types.SET_FOCUS_DATE,
    direction,
    increment
});

export const setFocusDateDirect = payload => ({
    type: types.SET_FOCUS_DATE_DIRECT,
    payload
});

export const toggleCalendarFilters = () => ({
    type: types.TOGGLE_CALENDAR_FILTERS
});

export const applyFilters = filters => (dispatch, getState) => {
    const calendarFilters = getState().calendar;
    const param = {
        startDate: calendarFilters.eventWindowStart.format('YYYY-MM-DD'),
        endDate: calendarFilters.eventWindowEnd.format('YYYY-MM-DD')
    };

    dispatch(fetchCalendarThunk(param, true));
};

export const applyCalendarFilters = filters => ({
    type: types.APPLY_CALENDAR_FILTERS,
    filters
});

export const updateCalendarDistrictSuccess = payload => ({
    type: types.UPDATE_CALENDAR_DISTRICT_SUCCESS,
    payload
});

export const updateCalendarRsSuccess = payload => ({
    type: types.UPDATE_CALENDAR_RS_SUCCESS,
    payload
});

export const updateCalendarRssOssSuccess = payload => ({
    type: types.UPDATE_CALENDAR_RSS_OSS_SUCCESS,
    payload
});

export const updateCalendarDistrict = e => (dispatch, getState) => {
    const region = typeof e === 'string' ? e : e.target.value;

    dispatch(actions.change('calendarFilters.districtCode', ''));
    dispatch(updateCalendarDistrictSuccess([]));
    dispatch(actions.change('calendarFilters.recruitingStationCode', ''));
    dispatch(updateCalendarRsSuccess([]));
    dispatch(actions.change('calendarFilters.rssOssCode', ''));
    dispatch(actions.change('calendarFilters.rssOssType', ''));
    dispatch(updateCalendarRssOssSuccess([]));

    const location = {
        regionCode: region,
        districtCode: '',
        recruitingStationCode: '',
        rssOssCode: '',
        rssOssType: ''
    };

    dispatch(locationsObject(location));

    apiRequest(
        `${endpoints.LOCATION_DISTRICT_LIST}${region}`,
        getState().auth.jwtToken
    ).then(payload => {
        dispatch(updateCalendarDistrictSuccess(payload.data));
    });
};

export const updateCalendarRS = e => (dispatch, getState) => {
    const districtCode = typeof e === 'string' ? e : e.target.value;

    dispatch(actions.change('calendarFilters.recruitingStationCode', ''));
    dispatch(updateCalendarRsSuccess([]));
    dispatch(actions.change('calendarFilters.rssOssCode', ''));
    dispatch(actions.change('calendarFilters.rssOssType', ''));
    dispatch(updateCalendarRssOssSuccess([]));

    const location = {
        regionCode: '',
        districtCode: districtCode,
        recruitingStationCode: '',
        rssOssCode: '',
        rssOssType: ''
    };

    dispatch(locationsObject(location));

    apiRequest(
        `${endpoints.LOCATION_RS_LIST}${districtCode}`,
        getState().auth.jwtToken
    ).then(payload => {
        dispatch(updateCalendarRsSuccess(payload.data));
    });
};

export const updateCalendarRssOss = e => (dispatch, getState) => {
    const rsCode = typeof e === 'string' ? e : e.target.value;
    const userBilletLocation = getState().data.userInfo.Billet.location;
    const location = {
        regionCode: '',
        districtCode: '',
        recruitingStationCode: '',
        rssOssCode: '',
        rssOssType: ''
    };

    if (rsCode === '') {
        dispatch(locationsObject(location));
        dispatch(actions.change('calendarFilters.rssOssCode', ''));
        dispatch(actions.change('calendarFilters.rssOssType', ''));
        dispatch(updateCalendarRssOssSuccess([]));
        return false;
    }

    if (userBilletLocation === 'RSS') {
        apiRequest(
            `${endpoints.LOCATION_RSS_LIST}${rsCode}`,
            getState().auth.jwtToken
        ).then(payload => {
            dispatch(
                updateCalendarRssOssSuccess(
                    searchFormat.formatOSSRSSDropdown(payload.data)
                )
            );
        });
    } else if (userBilletLocation === 'OSS') {
        apiRequest(
            `${endpoints.LOCATION_OSS_LIST}${rsCode}`,
            getState().auth.jwtToken
        ).then(payload => {
            dispatch(
                updateCalendarRssOssSuccess(
                    searchFormat.formatOSSRSSDropdown(payload.data)
                )
            );
        });
    } else {
        apiRequest(
            `${endpoints.LOCATION_RSS_LIST}${rsCode}`,
            getState().auth.jwtToken
        ).then(payload => {
            let RssList = payload.data;
            apiRequest(
                `${endpoints.LOCATION_OSS_LIST}${rsCode}`,
                getState().auth.jwtToken
            ).then(payload => {
                dispatch(
                    updateCalendarRssOssSuccess(
                        searchFormat.formatOSSRSSDropdown(
                            payload.data.concat(RssList)
                        )
                    )
                );
            });
        });
    }
};

export const updateCalendarRssOssType = e => (dispatch, getState) => {
    //update here to get the right oss rss type
    const ossRssType = e.target[e.target.selectedIndex].getAttribute(
        'data-type'
    );
    dispatch(actions.change('calendarFilters.rssOssType', ossRssType));
};

export const onLoadCalendarLocations = model => (dispatch, getState) => {
    const userInfo = getState().data.userInfo;
    const regionCode = userInfo.regionCode ? userInfo.regionCode : '';
    const districtCode =
        userInfo.District !== null ? userInfo.District.code : '';
    const rsCode = userInfo.RS !== null ? userInfo.RS.code : '';
    const rssCode = userInfo.RSS !== null ? userInfo.RSS.code : '';
    const ossCode = userInfo.OSS !== null ? userInfo.OSS.ossNumber : '';
    const rssOssCode = rssCode || ossCode;
    let rssOssType = '';
    if (rssCode !== '' && rssOssCode) {
        rssOssType = '-RSS';
    } else if (ossCode !== '' && rssOssCode) {
        rssOssType = '-OSS';
    }

    dispatch(actions.change(`${model}.regionCode`, regionCode));
    dispatch(updateCalendarDistrict(regionCode));
    dispatch(actions.change(`${model}.districtCode`, districtCode));
    dispatch(updateCalendarRS(districtCode));
    dispatch(actions.change(`${model}.recruitingStationCode`, rsCode));
    dispatch(updateCalendarRssOss(rsCode));
    dispatch(
        actions.change(`${model}.rssOssCode`, `${rssOssCode}${rssOssType}`)
    );
    dispatch(
        actions.change(`${model}.rssOssType`, rssOssType.replace('-', ''))
    );

    const location = {
        regionCode: regionCode,
        districtCode: districtCode,
        recruitingStationCode: rsCode,
        rssOssCode: `${rssOssCode}${rssOssType}`,
        rssOssType: rssOssType.replace('-', '')
    };
    dispatch(locationsObject(location));
};

export const locationsObject = ({
    regionCode,
    districtCode,
    recruitingStationCode,
    rssOssCode,
    rssOssType
}) => (dispatch, getState) => {
    const filters = getState().calendarFilters;
    const location = {
        regionFilter: regionCode ? regionCode : filters.regionCode,
        districtFilter: districtCode ? districtCode : filters.districtCode,
        rSFilter: recruitingStationCode
            ? recruitingStationCode
            : filters.rsCode,
        rSSFilter: rssOssCode ? rssOssCode : filters.rssOssCode,
        rSSFilterType: rssOssType ? rssOssType : filters.rssOssType
    };

    dispatch(setCalendarLocationsValue(location));
};

export const setCalendarLocationsValue = locations => ({
    type: types.ONLOAD_CALENDAR_LOCATIONS,
    regionFilter: locations.regionFilter,
    districtFilter: locations.districtFilter,
    rSFilter: locations.rSFilter,
    rSSFilter: locations.rSSFilter.toString(),
    rSSFilterType: locations.rSSFilterType
});



// WEBPACK FOOTER //
// ./src/actions/calendar.js